<template>
  <v-container>
    <v-form>
      <v-text-field label="Фамилия имя отчество" v-model="user.name" required/>
      <v-text-field label="Псевдоним" v-model="user.nickname" required/>
      <v-select label="Дом" v-model="user.houseId" :items="houses"/>
      <v-text-field label="Номер квартиры" v-model="user.flat" required/>
      <v-switch label="Напоминать по email" v-model="user.isRemind"/>
      <slot v-for="(item, index) in user.emails">
        <v-text-field type="email" v-model="user.emails[index]" :key="index" placeholder="новый email адрес"
                      hide-details ref="emailInput" :append-icon="user.emails.length > 1 ? 'mdi-delete' : null"
                      @click:append="removeEmail(index)"/>
      </slot>
      <v-btn class="mr-4 mb-4" @click="addEmail">Добавить eMail</v-btn>
      <v-spacer class="pa-4"></v-spacer>
      <v-btn class="mr-4 mb-4" @click="saveUser">Сохранить</v-btn>
      <v-btn class="mr-4 mb-4" @click="cancelUser">Отменить</v-btn>
      <v-btn class="mr-4 mb-4" @click.stop="confirmation = true" v-if="user.id != null && user.id">Удалить</v-btn>
      <v-dialog v-model="confirmation" persistent width="290" @keydown.esc="cancelDeleteUser">
        <v-card>
          <v-toolbar dark dense flat>
            <v-icon>mdi-alert-outline</v-icon>
            <v-toolbar-title class="white--text">Удаление</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4">Вы действительно желаете удалить пользователя и все его записи?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="confirmDeleteUser">Удалить</v-btn>
            <v-btn @click="cancelDeleteUser">Отменить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-container>

</template>

<script>
export default {
  name: 'UserEdit',
  props: {
    userId: String
  },
  data() {
    return {
      confirmation: false,
      focusLastEmail: false,
      valid: false,
      houses: [],
      user: {
        id: "",
        houseId: "",
        emails: [""],
        flat: "",
        name: "",
        nickname: "",
        isRemind: false,
      }
    }
  },
  mounted() {
    const userId = this.userId
    console.log(`UserEdit ${userId}`)
    if (userId) {
      this.$http.get(`/user/${userId}`).then(resp => this.user = resp.data)
    }
    this.$http.get('/house').then(resp =>
        this.houses = resp.data.map(h => {
          return {
            text: `${h.city}, ${h.street}, ${h.number}`,
            value: h.id
          }
        })
    )
  },
  updated() {
    if (this.focusLastEmail) {
      const n = this.user.emails.length - 1
      this.$refs.emailInput[n].focus()
      this.focusLastEmail = false
    }
  },
  methods: {
    saveUser: function () {
      this.$http.post("/user/", this.user).then(() => this.$router.push({name: 'Users'}))
    },
    cancelUser: function () {
      this.$router.push({name: 'Users'})
    },
    addEmail: function () {
      this.user.emails.push("")
      this.focusLastEmail = true
    },
    removeEmail: function (index) {
      this.user.emails.splice(index, 1)
    },
    cancelDeleteUser: function () {
      this.confirmation = false
    },
    confirmDeleteUser: function () {
      this.confirmation = false
      this.$http.delete(`/user/${this.user.id}`).then(() => this.$router.push({name: 'Users'}))
    }
  }

}
</script>